exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tamanho[data-v-2cfe64f8]{\n    width: 300px;\n}\n", ""]);

// exports
